<template>
  <div id="error-page">
    <div style="text-align: center">
      <h1>Dostęp do multibooka wygasł.</h1>
      <br />
      <h1>Prosimy o kontakt z konsultantem oświatowym.</h1>
      <div class="logo-mac">
        <img style="height: 20vmin; width: 20vmin" src="./logoMAC_kolor.png" alt="Logo MAC S.A." />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'error-page',

  data: function () {
    return {};
  },
  beforeRouteEnter(to, from, next) {
    next();
  },
  methods: {},
};
</script>

<style lang="sass">
#error-page
  width: 100vw
  height: calc(var(--vh, 1vh) * 100)
  background: #0054a3
  display: flex
  justify-content: center
  align-items: center
  h1
    color: white
.logo-mac
  height: 20vmin
  width: 100%
  position: absolute
  bottom: 10vmin
  left: 0
  display: flex
  justify-content: center
</style>
